// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__3yIwr","modalFooterButton":"ModalNotes_modalFooterButton__l3ket"};